var firebase = require('../firebase');
var toastr = require('toastr');

var { fbDb } = firebase;

module.exports = {
	fetching: function() {
		return {
			type: "DATA_FETCHING"
		};
	},

	loadSettingsSuccess: function(settings) {
		return {
			type: "LOAD_SETTINGS_SUCCESS",
			payload: settings
		};
	},

	updateSettingSuccess: function(setting) {
		return {
			type: "UPDATE_SETTING_SUCCESS",
			payload: setting
		};
	},

	unloadSettings: function() {
		return {
			type: "UNLOAD_SETTINGS"
		}
	},

	set(key, value) {
		return new Promise((resolve, reject) => {
			fbDb.ref(`settings/${key}`)
			.set(value, error => error ? reject(error) : resolve());
		});
	},

	getKmMark: function(kmMax) {
		var markConfig;

		switch(true) {
			case kmMax > 9999 && kmMax <= 20000:
				markConfig = { mark: 10, markLabel: '10 até 20'};
				break;
				
			case kmMax > 19999 && kmMax <= 30000:
				markConfig = { mark: 20, markLabel: '20 até 30'};
				break;

			case kmMax > 29999 && kmMax <= 40000:
				markConfig = { mark: 30, markLabel: '30 até 40'};
				break;

			case kmMax > 39999 && kmMax <= 50000:
				markConfig = { mark: 40, markLabel: '40 até 50'};
				break;

			case kmMax > 49999 && kmMax <= 60000:
				markConfig = { mark: 50, markLabel: '50 até 60'};
				break;

			case kmMax > 59999 && kmMax <= 70000:
				markConfig = { mark: 60, markLabel: '60 até 70'};
				break;

			case kmMax > 69999 && kmMax <= 80000:
				markConfig = { mark: 70, markLabel: '70 até 80'};
				break;

			case kmMax > 79999 && kmMax <= 90000:
				markConfig = { mark: 80, markLabel: '80 até 90'};
				break;

			case kmMax > 89999 && kmMax <= 100000:
				markConfig = { mark: 90, markLabel: '90 até 100'};
				break;

			case kmMax > 100000:
				markConfig = { mark: 100, markLabel: '> 100'};
				break;

			default:
				markConfig = { mark: 0, markLabel: 'até 10'};
				break;
		}

		return markConfig;
	},

	unwrapKmPrice: function(settings) {
		var me = this, kmPrice = [];

		for(var key in settings.kmPrice) {
			var { kmMax } = settings.kmPrice[key],
				{ mark, markLabel } = me.getKmMark(kmMax);

			kmPrice.push(
				Object.assign(
					{}, settings.kmPrice[key], {key: key, mark: mark, markLabel: markLabel}
				)
			);
		}

		return kmPrice;
	},

	unwrapKmPriceNight: function(settings) {
		var me = this, kmPriceNight = [];

		for(var key in settings.kmPriceNight) {
			var { kmMax } = settings.kmPriceNight[key],
				{ mark, markLabel } = me.getKmMark(kmMax);

			kmPriceNight.push(
				Object.assign(
					{}, settings.kmPriceNight[key], {key: key, mark: mark, markLabel: markLabel}
				)
			);
		}

		return kmPriceNight;
	},

	unwrapKmPriceUpd: function(settings) {
		var me = this, kmPrice = [];

		for(var key in settings) {
			var { kmMax } = settings[key],
				{ mark, markLabel } = me.getKmMark(kmMax);

			kmPrice.push(
				Object.assign(
					{}, settings[key], {key: key, mark: mark, markLabel: markLabel}
				)
			);
		}

		return kmPrice;
	},

	unwrapKmPriceNightUpd: function(settings) {
		var me = this, kmPriceNight = [];

		for(var key in settings) {
			var { kmMax } = settings[key],
				{ mark, markLabel } = me.getKmMark(kmMax);

			kmPriceNight.push(
				Object.assign(
					{}, settings[key], {key: key, mark: mark, markLabel: markLabel}
				)
			);
		}

		return kmPriceNight;
	},

	loadSettings: function() {
		var me = this;

		return function(dispatch) {
			var ref = fbDb.ref('settings');

			ref.once('value', (snap) => {
				var settings = snap.val(), 
					kmPrice = me.unwrapKmPrice(settings),
					kmPriceNight = me.unwrapKmPriceNight(settings);

				dispatch(me.loadSettingsSuccess(Object.assign(
					{}, settings, {kmPrice: kmPrice, kmPriceNight: kmPriceNight})
				));
			});

			ref.on('child_changed', snap => {
				var value = snap.key === 'kmPrice' ? me.unwrapKmPriceUpd(snap.val()) : (snap.key === 'kmPriceNight' ? me.unwrapKmPriceNightUpd(snap.val()) : snap.val());

				dispatch(me.updateSettingSuccess({
					key: snap.key,
					value: value
				}));
			});

			me._unsubscribe = () => ref.off();
		}
	},

	unsubscribe: function() {
		var me = this;

		return function(dispatch) {
			me._unsubscribe();
			
			dispatch(me.unloadSettings());
		};
	},

	updateSetting: function(key, data) {
		var me = this;

		return function(dispatch) {
			me.set(key, data)
			.catch(() => {
				toastr.error('Ocorreu um erro ao atualizar o registro.');
			})
		}
	}
};


// WEBPACK FOOTER //
// ./src/actions/settingActions.js